import React, { Suspense, useState } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import { makeStyles } from '@material-ui/styles';
import { LinearProgress } from '@material-ui/core';

// import Selectors from 'redux/Selectors';
import { Footer } from 'components';
import appRoutes from 'routes/appRoutes';

import { TopBar, SideBar } from './components';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  topBar: {
    zIndex: 2,
    position: 'relative',
  },
  container: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    height: 'calc(100vh - 64px)',
    zIndex: 1,
  },
  navBar: {
    zIndex: 1,
    width: 200,
    minWidth: 200,
    flex: '0 0 auto',
    height: 'calc(100vh - 64)',
  },
  content: {
    zIndex: 1,
    overflowY: 'auto',
    flex: '1 1 auto',
  },
  background: {
    position: 'absolute',
    zIndex: '0',
    height: '100%',
    width: '100%',
    display: 'block',
    top: '0',
    left: '0',
    opacity: 0.2,
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    '&:after': {
      position: 'absolute',
      zIndex: '3',
      width: '100%',
      height: '100%',
      content: '""',
      display: 'block',
    },
  },
}));

const routes = (
  <Switch>
    {appRoutes.map((prop, key) => {
      if (prop.redirect) {
        return <Redirect from={prop.path} to={prop.to} key={key} />;
      }
      return <Route {...prop} key={key} />;
    })}
  </Switch>
);

const App = () => {
  const classes = useStyles();
  const [openSideBarMobile, setOpenSideBarMobile] = useState(false);

  const handleSideBarMobileOpen = () => {
    setOpenSideBarMobile(true);
  };

  const handleSideBarMobileClose = () => {
    setOpenSideBarMobile(false);
  };

  return (
    <div className={classes.root}>
      <Suspense fallback={<LinearProgress />}>
        <TopBar className={classes.topBar} onOpenSideBarMobile={handleSideBarMobileOpen} />
        <div className={classes.container}>
          <SideBar className={classes.navBar} onMobileClose={handleSideBarMobileClose} openMobile={openSideBarMobile} />
          <main className={classes.content}>
            <Suspense fallback={<LinearProgress />}>{routes}</Suspense>
          </main>
          <div className={classes.background} />
        </div>
        <Footer />
      </Suspense>
    </div>
  );
};

export default App;
